import {
    GET_INVOICE_SETTINGS,
    GET_INVOICE_SETTINGS_SUCCESS,
    GET_INVOICE_SETTINGS_FAILURE,
    UPDATE_INVOICE_SETTINGS,
    UPDATE_INVOICE_SETTINGS_SUCCESS,
    UPDATE_INVOICE_SETTINGS_FAILURE
} from '../../../actions/index.types';

const initialState = {
    invoiceSettings: null,
    loading: false,
    error: null,
    updateLoading: false,
    updateError: null,
    updateSuccess: false
}

const InvoiceSettingReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get Settings
        case GET_INVOICE_SETTINGS:
            return {
                ...state,
                loading: true,
                // Drop the previous bill type's settings while the new type's
                // request is in flight, so the form can never paint one type's
                // values under another type's name.
                invoiceSettings: null,
                error: null
            }
        case GET_INVOICE_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                invoiceSettings: action.data,
                error: null
            }
        case GET_INVOICE_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.data
            }

        // Update Settings
        case UPDATE_INVOICE_SETTINGS:
            return {
                ...state,
                updateLoading: true,
                updateError: null,
                updateSuccess: false
            }
        case UPDATE_INVOICE_SETTINGS_SUCCESS:
            // Optionally update the local state with the new settings if returned,
            // or just flag success to trigger a re-fetch or UI update.
            return {
                ...state,
                updateLoading: false,
                updateSuccess: true,
                // update invoiceSettings if the API returns the updated object
                // invoiceSettings: action.data
            }
        case UPDATE_INVOICE_SETTINGS_FAILURE:
            return {
                ...state,
                updateLoading: false,
                updateError: action.data,
                updateSuccess: false
            }

        default:
            return state
    }
}

export default InvoiceSettingReducer
